import api from '@/api'
import _ from 'lodash'

const state = {
  steps: [],
}

const getters = {
  steps: state => state.steps
}

const mutations = {

  setSteps (state, steps) {
    state.steps = steps
  },

  setTaskStatus (state, taskStatus) {
    _.forEach(state.steps, s => {
      var task = _.find(s.tasks, t => t.id == taskStatus.id)
      if (task) {
        task.status = taskStatus.status
      }
    })
  },

  setStatuses (state, taskStatuses) {

    const isFinished = ids => {
      return _.filter(taskStatuses, ts => {
        return _.find(ids, id => id === ts.taskId)
      }).length === ids.length
    }

    const isBlocked = t => {
      return t.blockedWhen ? _.findIndex(taskStatuses, ts => ts.taskId === t.blockedWhen) !== -1 : false
    }

    // 1. set who's finished
    _.forEach(state.steps, s => {
      _.forEach(s.tasks, t => {
        var taskStatus = _.find(taskStatuses, ts => ts.taskId === t.id)
        if (taskStatus) {
          t.status = 'finished'
          t.date = taskStatus.createdOn
        }
      })
    })

    // 2. set who's ready (not finished && dependencies == finished)
    _.forEach(state.steps, s => {
      _.forEach(s.tasks, t => {
        if (isBlocked(t)) {
          t.status = 'finished'
        } else if (!_.find(taskStatuses, ts => ts.taskId === t.id) && isFinished(t.dependencies || [])) {
          t.status = 'ready'
        }
      })
    })

    // 3. current step (last step with ready task, prior = finished, following = pending)
    let lastStepIndexWithReadyTask = _.findLastIndex(state.steps, s => _.filter(s.tasks, t => t.status === 'ready').length > 0)
    _.forEach(state.steps, (s, index) => {
      s.status = lastStepIndexWithReadyTask === -1 ? 'finished' :
                 lastStepIndexWithReadyTask > index ? 'finished' :
                 lastStepIndexWithReadyTask < index ? 'pending' : 'active'
    })

  }
}

const actions = {

  async updateStatuses ({ commit }) {
    const taskStatuses = await api.af.getTaskStatuses()
    commit('setStatuses', taskStatuses)
  },

  async init ({ commit, dispatch }) {
    const steps = require('@/data/steps-af.json')
    commit('setSteps', steps)
    await dispatch('updateStatuses')
  },

  startTask ({ commit }, id) {
    commit('setTaskStatus', { id, status: 'started' })
  },

  async finishTask ({ dispatch, getters }, id) {
    await api.af.createTaskStatus(id)
    await dispatch('updateStatuses')
    const activeStepIndex = _.findIndex(getters.steps, s => s.status === 'active')
    const nextIndex = activeStepIndex !== -1 ? activeStepIndex + 1 : getters.steps.length
    await api.af.updateElectionPeriodActiveStep(nextIndex)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}